import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

// Translate
import { TranslateModule } from '@ngx-translate/core'

import { BackButtonDirective } from './directives/back-button.directive'

import { SlugifyPipe } from './pipes/slugify/slugify.pipe'
import { FormatFromCentsPipe } from './pipes/format-from-cents/format-from-cents.pipe'
import { FilterMenuItemOptionsPipe } from './pipes/filter-menu-item-options.pipe'

import { SharedButtonModule } from './shared-button/shared-button.module'
import { FontAccessibilityModule } from './font-accessibility/font-accessibility.module'

@NgModule({
	imports: [CommonModule, TranslateModule],
	exports: [
		CommonModule,
		TranslateModule,
		BackButtonDirective,
		FormatFromCentsPipe,
		SlugifyPipe,
		FilterMenuItemOptionsPipe,
		FontAccessibilityModule,
		SharedButtonModule,
	],
	declarations: [
		BackButtonDirective,
		FormatFromCentsPipe,
		SlugifyPipe,
		FilterMenuItemOptionsPipe
	],
})
export class SharedModule {}
